exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3R-bmeKharbm7MQ-lmj7Ik{padding:0 10px}.ON6wrGZlSvputXqoPoRsR{color:#fff;margin:0 -10px;padding:10px;line-height:36px}.ON6wrGZlSvputXqoPoRsR svg{margin-right:10px;vertical-align:sub}._70lGn9FKgTMOQ_XrTdavF{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:0}._3BQHaNl0oI54koVOtySM0f{margin-top:20px;text-align:right}", ""]);

// exports
exports.locals = {
	"root": "_3R-bmeKharbm7MQ-lmj7Ik",
	"platformTitle": "ON6wrGZlSvputXqoPoRsR",
	"channelTitle": "_70lGn9FKgTMOQ_XrTdavF",
	"actions": "_3BQHaNl0oI54koVOtySM0f"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/postcss-loader!./components/forms/media-platform.css
 ** module id = 1019
 ** module chunks = 0
 **/